module.exports = "{{#curves}}\n<option>{{.}}</option>\n{{/curves}}\n"